import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75671f4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-c-hub-endpoint-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_breadcrumb = _resolveComponent("base-breadcrumb")!
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_endpoint_header = _resolveComponent("endpoint-header")!
  const _component_versions_dynamic_view = _resolveComponent("versions-dynamic-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_versions_dynamic_view, null, {
      fmd: _withCtx(() => [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (!_ctx.isPdfContent)
              ? (_openBlock(), _createBlock(_component_endpoint_header, {
                  key: 0,
                  "arrow-nav-path": `/covid-hub/gallery/${_ctx.sectionId}`
                }, {
                  "left-side": _withCtx(() => [
                    _createVNode(_component_base_breadcrumb, {
                      levels: _ctx.breadcrumbsLevels,
                      separator: "|"
                    }, null, 8, ["levels"])
                  ]),
                  "right-side": _withCtx(() => [
                    _createVNode(_component_base_button, {
                      callback: _ctx.openPDF,
                      callbackString: "https://labeling.pfizer.com/ShowLabeling.aspx?id=16474"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lyra_asset, { "asset-key": "app-link-eua-fact-sheet" })
                      ]),
                      _: 1
                    }, 8, ["callback"])
                  ]),
                  _: 1
                }, 8, ["arrow-nav-path"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      galaxy: _withCtx(() => [
        _createVNode(_component_endpoint_header, null, {
          "right-side": _withCtx(() => [
            (_ctx.isProduct)
              ? (_openBlock(), _createBlock(_component_base_button, {
                  key: 0,
                  callback: _ctx.openPDF,
                  callbackString: "https://www.fda.gov/media/155049/download",
                  class: "analytics-click",
                  "data-analytics-name": "external-link",
                  "data-analytics-id": "https://www.fda.gov/media/155049/download"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lyra_asset, { "asset-key": "app-link-eua-fda-letter" })
                  ]),
                  _: 1
                }, 8, ["callback"]))
              : _createCommentVNode("", true),
            (_ctx.isProduct)
              ? (_openBlock(), _createBlock(_component_base_button, {
                  key: 1,
                  callback: _ctx.openPDF,
                  callbackString: "https://labeling.pfizer.com/ShowLabeling.aspx?id=16473",
                  class: "analytics-click",
                  "data-analytics-name": "external-link",
                  "data-analytics-id": "https://labeling.pfizer.com/ShowLabeling.aspx?id=16473"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lyra_asset, { "asset-key": "app-link-eua-fact-sheet-patients" })
                  ]),
                  _: 1
                }, 8, ["callback"]))
              : _createCommentVNode("", true),
            (_ctx.isProduct)
              ? (_openBlock(), _createBlock(_component_base_button, {
                  key: 2,
                  callback: _ctx.openPDF,
                  callbackString: "https://labeling.pfizer.com/ShowLabeling.aspx?id=16474",
                  class: "analytics-click",
                  "data-analytics-name": "external-link",
                  "data-analytics-id": "https://labeling.pfizer.com/ShowLabeling.aspx?id=16474"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lyra_asset, { "asset-key": "app-link-eua-fact-sheet-hcp" })
                  ]),
                  _: 1
                }, 8, ["callback"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citationsTypes, (citation) => {
              return (_openBlock(), _createBlock(_component_base_button, {
                key: citation,
                callback: _ctx.processOverlay,
                callbackString: citation,
                class: _normalizeClass([[
								{ 'is-inactive': !_ctx.citationsType.includes(citation) },
							], "crux-click"]),
                "data-crux": "citations-handle",
                "data-analytics-name": "citations",
                "data-analytics-id": _ctx.toKebabCaseId(citation)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lyra_asset, {
                    "asset-key": `app-link-button-${_ctx.toKebabCaseId(citation)}`
                  }, null, 8, ["asset-key"])
                ]),
                _: 2
              }, 1032, ["callback", "callbackString", "class", "data-analytics-id"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}